import React, { useState } from 'react';
import styled from '@emotion/styled';
import type { ObjectType } from '@src/types/misc';
import {
  $blue600,
  $fontSize3,
  $fontStackPrimary,
  $fontWeightBold
} from '@src/variables';

type TProps = ObjectType & {
  image: string;
  hoverImage: string;
};

const Button = styled.button({
  alignItems: 'center',
  background: '#ffffff',
  color: $blue600,
  display: 'flex',
  flexDirection: 'column',
  fontFamily: $fontStackPrimary,
  fontSize: $fontSize3,
  fontWeight: $fontWeightBold,
  height: '100%',
  outline: 'none',
  paddingBottom: '1.1rem',
  paddingTop: '1.1rem',
  width: 63,
  span: {
    display: 'flex',
    flexGrow: 1,
    alignItems: 'center',
    lineHeight: 1.2
  }
});

export default function StyledButton(props: TProps): React.ReactElement {
  const { children, image, hoverImage, ...otherProps } = props;
  const [hovered, setHovered] = useState(false);

  return (
    <Button
      type="button"
      onBlur={() => setHovered(false)}
      onFocus={() => setHovered(true)}
      onPointerEnter={() => setHovered(true)}
      onPointerLeave={() => setHovered(false)}
      {...otherProps}
    >
      <img src={hovered ? hoverImage : image} />
      <span>{children}</span>
    </Button>
  );
}
